import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { storageService } from "Services/storage_service";
import { clientRoutes, adminRoutes, RUTAS } from "rutas";
import { ROLES } from "Constantes/constants";

export const RutaPrivada = ({ children }) => {
  const { pathname } = useLocation();
  const user = storageService.getItem("user");
  const isAuthenticated = Boolean(user?.token);

  if (!isAuthenticated) {
    return <Navigate to={RUTAS.PRINCIPAL} />;
  }

  const isClientRoute = clientRoutes.includes(pathname);
  const isAdminRoute = adminRoutes.some((route) => route.path === pathname);
  const isAdmin = user.idRol && user.idRol !== ROLES.NO_CLIENTE.ID;

  if (isAdmin && !isAdminRoute) {
    return <Navigate to={RUTAS.ADMIN_HOME} replace />;
  }

  if (!isAdmin && !isClientRoute) {
    return <Navigate to={RUTAS.PRINCIPAL} replace />;
  }

  return children;
};
